module.exports = __webpack_public_path__ + "img/petronas.be371fbe.svg";